import React, { useEffect, useState } from "react";

import {
  Card,
  CardBody,
  Row,
  Col,
  Label,
  Input,
  Button,
} from "reactstrap";

import { useSearchParams, useNavigate } from "react-router-dom";

import swal from "sweetalert";

import axiosConfig from "../../AxiosConfig";

export default function EditWarehouse() {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const id = searchParams.get("id");

  const [formData, setFormData] = useState({
    warehouseName: "",
    id: "",
    warehouseType: "",
    mobileNo: "",
    landlineNumber: "",
    Username: "",
    Password: "",
    address: "",
    status: "Active",
  });

  // =====================================================
  // FETCH SINGLE WAREHOUSE
  // =====================================================

  const fetchWarehouse = async () => {
    try {
      const res = await axiosConfig.get(
        `/warehouse/view-warehouse-by-id/${id}`
      );

      console.log("EDIT DATA =>", res);

      const data = res?.data?.Warehouse;

      setFormData({
        warehouseName: data?.warehouseName || "",

        id: data?.id || "",

        // ================================================
        // WAREHOUSE TYPE
        // ================================================
        warehouseType: data?.warehouseType || "",

        mobileNo: data?.mobileNo || "",

        landlineNumber: data?.landlineNumber || "",

        Username: data?.Username || "",

        Password: data?.Password || "",

        address: data?.address || "",

        status: data?.status || "Active",
      });
    } catch (err) {
      console.log("FETCH WAREHOUSE ERROR =>", err);
    }
  };

  useEffect(() => {
    if (id) {
      fetchWarehouse();
    }
  }, [id]);

  // =====================================================
  // HANDLE CHANGE
  // =====================================================

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // =====================================================
  // UPDATE
  // =====================================================

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        warehouseName: formData.warehouseName,

        id: formData.id,

        // ================================================
        // WAREHOUSE TYPE
        // ================================================
        warehouseType: formData.warehouseType,

        mobileNo: formData.mobileNo,

        landlineNumber: formData.landlineNumber,

        Username: formData.Username,

        Password: formData.Password,

        address: formData.address,

        status: formData.status,
      };

      console.log(
        "UPDATE WAREHOUSE PAYLOAD =>",
        payload
      );

      const res = await axiosConfig.put(
        `/warehouse/update-warehouse/${id}`,
        payload
      );

      console.log(
        "UPDATE RESPONSE =>",
        res
      );

      await swal(
        "Success",
        "Warehouse Updated Successfully",
        "success"
      );

      navigate("/production?view=warehouse");
    } catch (err) {
      console.log(
        "UPDATE WAREHOUSE ERROR =>",
        err?.response?.data || err
      );

      swal(
        "Error",
        err?.response?.data?.message ||
          "Failed To Update Warehouse",
        "error"
      );
    }
  };

  return (
    <div className="erp-page-grid">
      <Card className="erp-card">
        <CardBody>
         <div className="d-flex justify-content-between align-items-center mb-3">
  <h3 className="mb-0">
    Edit Warehouse
  </h3>

 <Button
  color="secondary"
  type="button"
  onClick={() =>
    navigate("/production?view=warehouse")
  }
>
  Back
</Button>
</div>

          <form onSubmit={handleSubmit}>

            {/* =====================================================
                FIRST ROW
            ====================================================== */}

            <Row>

              {/* WAREHOUSE NAME */}

              <Col md="4">
                <Label>
                  Warehouse Name
                </Label>

                <Input
                  value={formData.warehouseName}
                  onChange={(e) =>
                    handleChange(
                      "warehouseName",
                      e.target.value
                    )
                  }
                />
              </Col>

              {/* WAREHOUSE ID */}

              <Col md="4">
                <Label>
                  Warehouse ID
                </Label>

                <Input
                  value={formData.id}
                  onChange={(e) =>
                    handleChange(
                      "id",
                      e.target.value
                    )
                  }
                />
              </Col>

              {/* WAREHOUSE TYPE */}

              <Col md="4">
                <Label>
                  Warehouse Type
                </Label>

                <Input
                  type="select"
                  value={formData.warehouseType}
                  onChange={(e) =>
                    handleChange(
                      "warehouseType",
                      e.target.value
                    )
                  }
                >
                  <option value="">
                    Select Warehouse Type
                  </option>

                  <option value="Trading">
                    Trading
                  </option>

                  <option value="Production">
                    Production
                  </option>
                </Input>
              </Col>

            </Row>

            {/* =====================================================
                SECOND ROW
            ====================================================== */}

            <Row className="mt-3">

              {/* MOBILE */}

              <Col md="4">
                <Label>
                  Mobile No
                </Label>

                <Input
                  value={formData.mobileNo}
                  onChange={(e) =>
                    handleChange(
                      "mobileNo",
                      e.target.value
                    )
                  }
                />
              </Col>

              {/* LANDLINE */}

              <Col md="4">
                <Label>
                  Landline No
                </Label>

                <Input
                  value={formData.landlineNumber}
                  onChange={(e) =>
                    handleChange(
                      "landlineNumber",
                      e.target.value
                    )
                  }
                />
              </Col>

              {/* USERNAME */}

              <Col md="4">
                <Label>
                  Username
                </Label>

                <Input
                  value={formData.Username}
                  onChange={(e) =>
                    handleChange(
                      "Username",
                      e.target.value
                    )
                  }
                />
              </Col>

            </Row>

            {/* =====================================================
                THIRD ROW
            ====================================================== */}

            <Row className="mt-3">

              {/* PASSWORD */}

              <Col md="4">
                <Label>
                  Password
                </Label>

                <Input
                  value={formData.Password}
                  onChange={(e) =>
                    handleChange(
                      "Password",
                      e.target.value
                    )
                  }
                />
              </Col>

              {/* ADDRESS */}

              <Col md="4">
                <Label>
                  Address
                </Label>

                <Input
                  value={formData.address}
                  onChange={(e) =>
                    handleChange(
                      "address",
                      e.target.value
                    )
                  }
                />
              </Col>

              {/* STATUS */}

              <Col md="4">
                <Label>
                  Status
                </Label>

                <Input
                  type="select"
                  value={formData.status}
                  onChange={(e) =>
                    handleChange(
                      "status",
                      e.target.value
                    )
                  }
                >
                  <option value="Active">
                    Active
                  </option>

                  <option value="Inactive">
                    Inactive
                  </option>
                </Input>
              </Col>

            </Row>

            {/* =====================================================
                BUTTON
            ====================================================== */}

            <Button
              color="primary"
              type="submit"
              style={{
                marginTop: "25px",
              }}
            >
              Update Warehouse
            </Button>

          </form>
        </CardBody>
      </Card>
    </div>
  );
}